<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 7px;">发布时间</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
        <input-select selectTitle="问题分类" :selectKey="'typeName'" selectWidth="180px" :selectData="typeNameList" @search="search" style="margin-left: 10px;"/>
      </div>
      <input-search placeholder="问题" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :deleteTipInfo="'是否确认删除热点问题？'" @toCurrentPage="toCurrentPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" tableOperationWidth="120px"/>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/EnterpriseFavour'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'party-information-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '惠企服务',
        name: 'latest-policy-manage'
      }, {
        value: '热点问题'
      }],
      operationArr: ['current'],
      tableHead: [{
        prop: 'title',
        label: '问题'
      }, {
        prop: 'answer',
        label: '回答'
      }, {
        prop: 'typeName',
        label: '问题分类',
        width: '100'
      }, {
        prop: 'publishTime',
        label: '发布时间',
        width: '120'
      }, {
        prop: 'viewNumber',
        label: '浏览量',
        width: '100'
      }, {
        prop: 'collectNumber',
        label: '收藏量',
        width: '100'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      typeNameList: [
        {
          key: '',
          label: '全部'
        }, {
          key: '人才问题',
          label: '人才问题'
        }, {
          key: '亲清在线',
          label: '亲清在线'
        }, {
          key: '疫情时期涉税问题',
          label: '疫情时期涉税问题'
        }, {
          key: '土地问题',
          label: '土地问题'
        }, {
          key: '资金问题',
          label: '资金问题'
        }, {
          key: '疫情时期供电问题',
          label: '疫情时期供电问题'
        }, {
          key: '手续审批问题',
          label: '手续审批问题'
        }, {
          key: '企业复工',
          label: '企业复工'
        }, {
          key: '教育',
          label: '教育'
        }, {
          key: '职业资格',
          label: '职业资格'
        }, {
          key: '证件办理',
          label: '证件办理'
        }, {
          key: '就业创业',
          label: '就业创业'
        }, {
          key: '户籍人口',
          label: '户籍人口'
        }, {
          key: '医疗卫生',
          label: '医疗卫生'
        }, {
          key: '婚育收养',
          label: '婚育收养'
        }, {
          key: '文化体育',
          label: '文化体育'
        }, {
          key: '公安消防',
          label: '公安消防'
        }, {
          key: '科技创新',
          label: '科技创新'
        }, {
          key: '福利救助',
          label: '福利救助'
        }, {
          key: '死亡殡葬',
          label: '死亡殡葬'
        }, {
          key: '人力资源',
          label: '人力资源'
        }, {
          key: '社会保障',
          label: '社会保障'
        }, {
          key: '旅游服务',
          label: '旅游服务'
        }, {
          key: '国土资源',
          label: '国土资源'
        }, {
          key: '住房建设',
          label: '住房建设'
        }, {
          key: '交通运输',
          label: '交通运输'
        }, {
          key: '环保气象',
          label: '环保气象'
        }, {
          key: '工商监管',
          label: '工商监管'
        }, {
          key: '安全生产',
          label: '安全生产'
        }, {
          key: '司法公正',
          label: '司法公正'
        }, {
          key: '规划测绘',
          label: '规划测绘'
        }, {
          key: '经济发展',
          label: '经济发展'
        }, {
          key: '财政税务',
          label: '财政税务'
        }, {
          key: '民族宗教',
          label: '民族宗教'
        }, {
          key: '外事侨务',
          label: '外事侨务'
        }, {
          key: '农林牧水',
          label: '农林牧水'
        }, {
          key: '公共事业',
          label: '公共事业'
        }, {
          key: '中介服务',
          label: '中介服务'
        }, {
          key: '质量技术监督',
          label: '质量技术监督'
        }, {
          key: '食品药物监管',
          label: '食品药物监管'
        }, {
          key: '新闻广电出版',
          label: '新闻广电出版'
        }, {
          key: '出入境',
          label: '出入境'
        }, {
          key: '其他',
          label: '其他'
        }
      ],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      timevalue: [],
      requestData: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1,
        startTime: '',
        endTime: '',
      },
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getCreatTime()
  },
  methods: {
    getPage () {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || ''
        this.requestData.endTime = this.timevalue[1] || ''
      } else {
        this.requestData.startTime = ''
        this.requestData.endTime = ''
      }
      this.$axios.post(api.getHotIssuePage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {})
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取失败'))
    },
    getCreatTime () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()

      let lastDate = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);//最后30天可以更改，意义：是获取多少天前的时间
      let lastY = lastDate.getFullYear();
      let lastM = (lastDate.getMonth() + 1) < 10 ? '0' + (lastDate.getMonth() + 1) : (lastDate.getMonth() + 1)
      let lastD = lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate()
      this.timevalue[0] = lastY + '-' + lastM + '-' + lastD
      this.timevalue[1] = year + '-' + month + '-' + date
      this.getPage()
    },
    search (v) {
      this.requestData.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    toCurrentPage (code) {
      this.$router.push({
        path: `/hotspot_issues_current/${code}`
      })
    },
  },
  watch: {
    timevalue (val) {
      this.getPage()
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/EnterpriseFavour/HotspotIssues/HotspotIssuesManage.vue